import {CommonOptionVM} from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

export class RepeatingGroupOptionsVM extends CommonOptionVM {

  constructor(data: Partial<RepeatingGroupOptionsVM> = {}) {
    super(data)
  }

  validateData() {
    const errors: any[] = []
    
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default RepeatingGroupOptionsVM